

let API_URL;

if (process.env.NODE_ENV === 'development') {
    API_URL = process.env.REACT_APP_API_URL || 'https://api.linkey.in/api';
} else {

    if (process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_URL.includes('localhost')) {
        API_URL = process.env.REACT_APP_API_URL;
    } else {
        API_URL = `${window.location.origin}/api`;
    }
}

export { API_URL };
